export default "__VITE_ASSET__DXtBFR0Z__"